import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { E2eFeatureFlagOverrideMap } from '@shared/interfaces/e2e-feature-flag-override.interface';
import { RestBuilder } from '../helpers/rest.builder';

interface IE2eFeatureFlagOverridesResponse {
  flags: E2eFeatureFlagOverrideMap;
}

@Injectable({
  providedIn: 'root',
})
export class E2eFeatureFlagOverridesApi {
  private restBuilder: RestBuilder;

  constructor(private httpClient: HttpClient) {
    this.restBuilder = new RestBuilder();
  }

  public getForCurrentUser(tenantId?: string): Observable<IE2eFeatureFlagOverridesResponse> {
    const url: string = this.restBuilder.create().e2e().e2eFeatureFlagOverrides().getApiUrl();
    const params: HttpParams = tenantId ? new HttpParams().set('tenantId', tenantId) : new HttpParams();
    return this.httpClient.get<IE2eFeatureFlagOverridesResponse>(url, { params });
  }
}
